import React from 'react';
import debounce from 'lodash/debounce';
import {UserSelector} from './UserSelector';
import UserSource from 'sources/UserSource';
import cancelIfSending from 'sources/cancelIfSending';
import {Map} from 'immutable';
import {associateBy} from 'utils/associateBy';
import UserActions from 'actions/UserActions';

const UserCancellableSource = cancelIfSending(UserSource);

const doSearch = debounce(
  (searchTerm, success, fail) =>
    searchTerm && UserCancellableSource.fetch({searchTerm}).then(success, fail),
  300
);

export default class UserSearchField extends React.PureComponent {
  state = {
    users: Map(),
  };

  search = searchTerm => {
    this.setState({
      searchTerm,
      isSearching: !!searchTerm,
      users: Map(),
    });
    doSearch(searchTerm, users => {
      UserActions.fetchAllSuccess(users);
      const filteredUsers = users.filter(user => !this.props.excludeUserIds.includes(user.id));
      this.setState({users: associateBy(filteredUsers, u => u.id), isSearching: false});
    });
  };

  render() {
    const {users} = this.state;
    return (
      <UserSelector
        users={users}
        onSearchChange={this.search}
        placeholder="Select a user"
        onChange={this.props.onChange}
        noOptionsText={
          this.state.isSearching
            ? 'Searching...'
            : !this.state.search
            ? 'Type to search users'
            : 'No users found matching the search text'
        }
      />
    );
  }
}
